import script from "./VersionComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./VersionComponent.vue?vue&type=script&setup=true&lang=ts"

import "./VersionComponent.vue?vue&type=style&index=0&id=0649eb7a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0649eb7a"]])

export default __exports__